import React from 'react';
import { stats } from '../data/content';
export function StatsBar() {
  return <section className="w-full border-y border-ink/10 bg-paper-deep" data-id="element-201" data-mp="1tarjq9bipqkw">
      <div className="mx-auto max-w-6xl px-8 py-14 sm:px-14 lg:flex lg:items-center lg:gap-14" data-id="element-202" data-mp="1t8dqm60eeofz">
        <h2 className="shrink-0 font-hand text-3xl leading-none text-pen lg:w-40" data-id="element-203" data-mp="1odhy74r91z2c">
          Le pack en chiffres
        </h2>
        <dl className="mt-8 grid grid-cols-2 gap-x-6 gap-y-10 lg:mt-0 lg:flex-1 lg:grid-cols-4" data-id="element-204" data-mp="1ed7mxporz1pt">
          {stats.map(stat => <div key={stat.label} className="flex flex-col-reverse border-l border-ink/15 pl-5" data-id="element-205" data-mp="19lg2lww7ps84">
              <dt className="mt-3 text-sm leading-snug text-ink/70" data-id="element-206" data-mp="15lywd18yor1w">{stat.label}</dt>
              <dd className="font-display text-6xl leading-none tracking-tight text-ink sm:text-7xl" data-id="element-207" data-mp="10mchkndhj2qz">
                {stat.value}
              </dd>
            </div>)}
        </dl>
      </div>
    </section>;
}